import { zonedTimeToUtc as zonedTimeToUtcFns, utcToZonedTime as utcToZonedTimeFns, } from 'date-fns-tz';
export const zonedTimeToUtc = (date, timeZone) => zonedTimeToUtcFns(date, timeZone ?? '');
export const utcToZonedTime = (date, timeZone) => utcToZonedTimeFns(date, timeZone ?? '');
export const setUtcGmtString = (date) => date.toString().replace(/GMT.\d+/, 'GMT+0000');
//# sourceMappingURL=converters.js.map